import type { Release } from '../releases';

export default {
  id: '2026-11-04-help-empty-hints',
  at: '2026-11-04T12:15:00Z',
  title: 'В «Помощи» каждого раздела — что делать, если список пуст',
  modules: ['support'],
  items: [
    'В панели «Помощь» любого раздела появился блок «Если здесь пусто»: откуда в разделе берутся записи и с чего начать.',
    'Например, на складе остатки появляются после проведения прихода, а в «Мой день» план берётся из графика проекта.',
    'Последняя подсказка блока напоминает проверить проект, отбор списка и права — и как попросить доступ.',
  ],
  why: 'Пустой список не объяснял, почему в нём ничего нет: человек не знал, ждать данных, создать первую запись или просить доступ.',
  link: '/support',
} satisfies Release;
